class CustomWaffleMaker extends HTMLElement {
  connectedCallback() {
    onLibReady(['vue'], this.#init.bind(this));
  }

  async #init() {
    const apiUrl = 'https://ald-custom.digitaluniverse.app/api';
    const fetchHeaders = {
      'Content-Type': 'application/json',
    };

    const JSON_HTML = this.querySelector('[data-json]');
    const data = JSON_HTML ? JSON.parse(JSON_HTML.innerHTML) : null;

    new Vue({
      el: this,
      data: {
        step: 1,
        steps: [
          {
            id: 1,
            title: 'Waffle type',
          },
          {
            id: 2,
            title: 'Upload Waffle images',
          },
          {
            id: 3,
            title: 'Waffles on a Mold',
          },
          {
            id: 4,
            title: 'Email address',
          },
        ],
        waffleTypes: data.waffleTypes,
        allCountryOptionTags: data.allCountryOptionTags,
        waffleType: null,
        waffleSize: null,
        images: [],
        imagesUrls: [],
        comment: null,
        email: null,
        loading: false,
        error: null,
        isSent: false,
      },
      template: `
        <div class="page-width" v-if="!isSent">
          <div class="custom-waffle-maker">
            <form method="post" action="/contact" id="contact_form" accept-charset="UTF-8" class="contact-form" ref="contactForm">
              <input type="hidden" name="form_type" value="contact">
              <input type="hidden" name="utf8" value="✓">
              <input type="hidden" name="contact[subject]" value="Custom Waffle Maker">
                  
              <h2 class="custom-waffle-maker__title">Get a Quote For a Waffle That Defines Your Brand</h2>    
                  
              <div class="custom-waffle-maker__progress">
                <div class="custom-waffle-maker__progress-item" :class="{done: step >= item.id }" v-for="item in steps" :key="item.id">
                    <div class="custom-waffle-maker__progress-item-status"></div>
                    <div class="custom-waffle-maker__progress-item-info">
                        <div class="custom-waffle-maker__progress-item-title">Step {{item.id}}</div>
                        <div class="custom-waffle-maker__progress-item-sub-title" v-if="step >= item.id">{{item.title}}</div>
                    </div>
                </div>
              </div>   
              
              <div v-if="step > 1">
                <a href="#" @click.prevent="backStep" class="custom-waffle-maker__prev-step link link--text link--accent" aria-label="Prev step">
                  <svg class="icon" width="26" height="15" viewBox="0 0 26 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.13081 0L8.28893 1.21799L3.13531 6.63785H26V8.36037H3.13531L8.28893 13.7802L7.13081 14.9982L0 7.49905L7.13081 0Z" fill="#66AC5A"/>
                  </svg>
                  <span>PREV STEP</span>
                </a>
              </div>
                  
              <div class="custom-waffle-maker__step" v-show="step === 1">
                <div class="waffle-types">
                  <div class="form-group center" style="max-width: 55rem; margin: 0 auto">
                    <p class="custom-waffle-maker__step-title">
                      Choose Your Waffle Style
                    </p>

                    <p class="promo-code__step-content">
                      Select the type of waffle you want to create — from classic shapes to filled, open-pocket, or stick options.
                    </p>
                  </div>
                
                  <div class="waffle-types__list">
                    <div class="waffle-type" v-for="(item, i) in waffleTypes">
                      <input :id="'waffle-type_' + i" type="radio" name="contact[waffle_type]" :value="item.title" style="display: none;" v-model="waffleType">
            
                      <label class="waffle-type" :for="'waffle-type_' + i">
                        <img class="waffle-type__img"
                          :srcset="item.image"
                          src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                          :alt="item.title"
                          loading="lazy"
                        >
                        
                        <div class="waffle-type__name">
                          {{item.title}}
                        </div>

                        <div class="waffle-type__subtitle" v-if="item.subtitle">
                          {{item.subtitle}}
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="custom-waffle-maker__step" v-show="step === 2">
                <div class="upload-images">
                  <div class="form-group center" style="max-width: 55rem; margin: 0 auto">
                    <p class="custom-waffle-maker__step-title">
                      Upload Waffle image
                    </p>
                    
                    <p class="promo-code__step-content">
                      If you have a sketch, image, or any visual reference for how your custom waffle should look, please upload it here. This helps us better understand your idea and bring it to life accurately (optional).
                    </p>
                  </div>
                  
                  <div class="upload-images__list" :class="{empty: !images.length}">
                    <div class="upload-images__item" v-for="(image, index) in images">
                      <div class="upload-images__item-remove" @click="removeImage(index)">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                          <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                        </svg>
                      </div>
                      <img :src="image" alt="Waffle image">
                    </div>
                    
                    <div class="upload-images__item">
                      <label class="upload-images__drop-area" v-show="images.length < 4">
                        <input style="display: none;" type="file" multiple accept="image/jpeg, image/png, image/jpg" @change="(evt) => uploadImages([...evt.target.files])" />
                        <input v-for="(url, i) in imagesUrls" type="hidden" :name="'contact[image_url_' + (i + 1) + ']'" :value="url" />
                        
                        <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.06671 7.00007C6.18444 7.00007 7.09325 6.10304 7.09325 5.00002C7.09325 3.897 6.18444 2.99998 5.06671 2.99998C3.94898 2.99998 3.03999 3.897 3.03999 5.00002C3.03999 6.10304 3.94898 7.00007 5.06671 7.00007Z"
                            fill="#CCCCCC"
                          />
                          <path
                            d="M17.7332 0H2.53326C1.13703 0 0 1.12206 0 2.5001V13.4999C0 14.8779 1.13703 16 2.53326 16H17.7332C19.1296 16 20.2667 14.8779 20.2667 13.4999V2.5001C20.2667 1.12206 19.1296 0 17.7332 0ZM2.53326 2.00005H17.7332C18.013 2.00005 18.2399 2.22398 18.2399 2.5001V9.59905L15.0389 5.91298C14.6994 5.52004 14.2078 5.31002 13.68 5.29812C13.155 5.30105 12.6626 5.53102 12.3262 5.92909L8.56259 10.3869L7.3365 9.17992C6.64349 8.49603 5.51555 8.49603 4.82346 9.17992L2.02672 11.9389V2.5001C2.02672 2.22398 2.25365 2.00005 2.53326 2.00005Z"
                            fill="#CCCCCC"
                          />
                        </svg>
                        
                        <p v-if="!images.length">Drag and drop an image here or <span>browse</span> to upload one.</p>
                        <p v-else><span>browse</span> for an images upload</p>
                      </label>
                    </div>
                  </div>   
                
                  <div class="form-group large">
                    <label for="comment">
                      <b>
                        Comment
                      </b>
                      <p>
                        Describe the shape, size, or other custom ideas you have for your waffle design - anything that helps us get it just right.
                      </p>
                    </label>
                    <textarea
                      id="comment"
                      class="form-control"
                      rows="9"
                      cols="75"
                      name="contact[body]"
                      v-model="comment"
                    ></textarea>
                  </div>

                  <div class="form-group large center">
                    <div class="form-button-group form-button-group--full-width">
                      <button class="button button--large button--accent" @click.prevent="nextStep" aria-label="Next step">Next step</button>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="custom-waffle-maker__step" v-show="step === 3">
                <div class="waffle-sizes">
                  <div class="form-group center">
                    <p class="custom-waffle-maker__step-title">
                      Select Waffle Count per Mold
                    </p>

                    <p class="promo-code__step-content">
                      Choose how many waffles you'd like the mold to make at once. This affects the size and layout of your custom mold.
                    </p>
                  </div>
                  
                  <div class="waffle-sizes__list">
                    <div class="waffle-size" v-for="(item, i) in [1, 2, 3, 4, 5, 'More']">
                      <input :id="'waffle-size_' + i" type="radio" name="contact[waffle_size]" :value="item" style="display: none;" v-model="waffleSize">
            
                      <label class="waffle-size" :for="'waffle-size_' + i">
                        <div class="waffle-size__name">
                          {{item}}
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="custom-waffle-maker__step" v-show="step === 4">
                <div class="address">
                  <div class="form-group center">
                    <p class="custom-waffle-maker__step-title">
                      Your email
                    </p>
                  </div>
                  
                  <div class="form-group">
                    <div class="form-group">
                      <label for="address_email">Email</label>
                      <input type="email" id="address_email" class="form-control" name="contact[email]" size="40" v-model="email" />
                    </div>
                  </div>
  
                  <div class="form-group large center">
                    <button type="submit" class="button button--large button--orange button--full" :class="{loading}" :disabled="!email" @click.prevent="handleSubmit">Submit</button>
                  </div>
                </div>
              </div>
              
              <div class="custom-waffle-maker__result">
                <div class="custom-waffle-maker__result-item form-group" v-if="waffleType && step > 1">
                  <b>Waffle type:</b> {{ waffleType }}
                </div>
                
                <div class="custom-waffle-maker__result-item form-group" v-if="waffleSize && step > 3">
                  <b>Waffles on a Mold:</b> {{ waffleSize }}
                </div>
                
                <div class="custom-waffle-maker__result-item form-group" v-if="step > 2">
                  <b>Comment:</b>
                  <span v-if="comment">
                    {{ comment }}
                  </span>
                   <span class="text-color-secondary" v-else>
                    Not provided
                  </span>
                </div>
                
                <div class="custom-waffle-maker__result-item form-group" v-if="step > 2">
                  <b>Upload Waffle images:</b>
                
                  <ul class="list-unstyled" v-if="images.length">
                    <li v-for="(image, index) in images">
                      <img :src="image" alt="Waffle image">
                    </li>
                  </ul>

                  <span class="text-color-secondary" v-else>
                    Not provided
                  </span>
                </div>
              </div>
              
              <div class="center" v-if="error">
                <div class="alert-error" v-html="error" />
              </div>
            </form>
          </div>  
        </div>
      `,

      async beforeMount() {
        const sessionData = getFormDataFromSession('customWaffleMaker');

        if (sessionData?.email) {
          this.isSent = true;

          try {
            const requestBody = {
              id: 47403081662696,
              properties: sessionData,
            };

            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(requestBody),
            });

            if (!response.ok) {
              throw new Error(`Failed to add to cart: ${response.status}`);
            }

            clearFormDataFromSession('customWaffleMaker');

            location.href = `/checkout?checkout[email]=${sessionData.email}`;
          } catch (error) {
            console.error('Error adding to cart:', error);
            clearFormDataFromSession('customWaffleMaker');
          }
        }
      },

      mounted() {
        const dropArea = document.querySelector('.upload-images__drop-area');

        if (dropArea) {
          ['dragenter', 'dragover'].forEach(eventName => {
            dropArea.addEventListener(
              eventName,
              evt => {
                evt.preventDefault();
                dropArea.classList.add('highlight');
              },
              false,
            );
          });

          ['dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(
              eventName,
              evt => {
                evt.preventDefault();
                dropArea.classList.remove('highlight');
              },
              false,
            );
          });

          dropArea.addEventListener(
            'drop',
            evt => {
              evt.preventDefault();
              dropArea.classList.remove('highlight');
              this.uploadImages([...evt.dataTransfer.files]);
            },
            false,
          );
        }
      },

      watch: {
        waffleType() {
          this.nextStep();
        },

        waffleSize() {
          this.nextStep();
        },
      },

      methods: {
        nextStep() {
          setTimeout(() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          });

          this.step++;
        },

        backStep() {
          this.step--;
        },

        uploadImages(files) {
          files = files.slice(0, 4 - this.images.length);

          files.forEach(file => {
            const reader = new FileReader();
            reader.onload = async () => this.images.push(reader.result);
            reader.onerror = error => console.error('Error: ', error);
            reader.readAsDataURL(file);
          });
        },

        removeImage(index) {
          this.images.splice(index, 1);
        },

        async handleSubmit() {
          this.loading = true;

          if (this.images.length) {
            try {
              const response = await fetch(`${apiUrl}/images`, {
                method: 'POST',
                body: JSON.stringify({images: this.images}),
                headers: fetchHeaders,
                signal: AbortSignal.timeout(3000),
              }).then(response => response.json());

              if (response.success) {
                this.imagesUrls = response.links;
              }
            } catch (e) {
              console.error(e);
            }
          }

          const formData = {
            email: this.email,
            waffle_type: this.waffleType,
            waffle_size: this.waffleSize,
            body: this.comment,
            ...this.imagesUrls.reduce((acc, url, index) => {
              acc[`image_url_${index + 1}`] = url;
              return acc;
            }, {}),
          };

          saveFormDataToSession(formData, 'customWaffleMaker');

          this.$nextTick(() => {
            this.$refs.contactForm.submit();
          });
        },
      },
    });
  }
}

customElements.define('custom-waffle-maker', CustomWaffleMaker);
